import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.toastNotification

export const getToastNotification = (state: RootState) =>
  root(state).toast === null ? undefined : root(state).toast
